import React from "react";

const Select = ({ name, label, options, error, reference, hideBlankItem, ...rest }) => {
    return (
        <div className="form-group">
            {label && <React.Fragment><label htmlFor={name}>{label}</label></React.Fragment>}
            <select name={name} id={name} ref={reference} {...rest} className="form-control">

                {(typeof hideBlankItem == 'undefined' || hideBlankItem == false) && <option value="" />}
                {options.map(option => (
                    <option key={option._id} value={option._id}>
                        {option.name}
                    </option>
                ))}
            </select>
            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    );
};

export default Select;
